<template>
  <Chart
    chartID="cognitive-function-chart"
    type="line"
    :labels="labels"
    :datasets="datasets"
    v-if="dataLoaded"
  ></Chart>
</template>

<script>
import Chart from "../../Chart.vue";

import { mapGetters } from "vuex";
import { format } from "date-fns";

export default {
  name: "Charts",
  props: ["existingEntries"],
  components: { Chart },
  data() {
    return {
      dataLoaded: false,
      labels: [],
      datasets: [
        {
          label: "Memory Problems",
          data: [],
          borderColor: ["rgba(255,201,56)"],
          backgroundColor: ["rgba(255,201,56)"],
          fill: false
        },
        {
          label: "Concentration Problems",
          data: [],
          borderColor: ["#002B4C"],
          backgroundColor: ["#002B4C"],
          fill: false
        },
        {
          label: "Clarity of Thought Problems",
          data: [],
          borderColor: ["#00B2AC"],
          backgroundColor: ["#00B2AC"],
          fill: false
        },
        {
          label: "Pain",
          data: [],
          backgroundColor: "gradient"
        }
      ]
    };
  },
  async mounted() {
    // Load our data and wait until it's done before setting loaded to true.
    await this.populateChart();
    this.dataLoaded = true;
  },
  computed: {
    ...mapGetters(["getPainEntries"])
  },
  methods: {
    populateChart() {
      this.existingEntries.forEach((entry, index) => {
        // Check for matching pain entries.
        const matchingPainIndex = this.getPainEntries.findIndex(
          painEntry => painEntry.date.seconds === entry.date.seconds
        );

        // Add our pain entry to the dataset.
        if (matchingPainIndex > -1) {
          this.existingEntries[index].painEntry = this.getPainEntries[
            matchingPainIndex
          ];
        }
      });

      this.existingEntries
        .slice()
        .reverse()
        .forEach(entry => {
          // Add label to chart.
          const day = format(entry.date.seconds * 1000, "MMMM D, YYYY");
          this.labels.push(day);

          // Add data to our chart.
          this.datasets[0].data.push(entry.data.memoryProblemLevel);
          this.datasets[1].data.push(entry.data.concentrationProblemLevel);
          this.datasets[2].data.push(entry.data.clarityOfThought);

          if (entry.painEntry) {
            this.datasets[3].data.push(entry.painEntry.data.painLevel);
          } else {
            this.datasets[3].data.push("");
          }
        });
    }
  }
};
</script>

<style>
</style>
